import { Modal, Table, Tag } from 'antd';
import { getUmsAdminLoginLog } from 'apis/sys';
import { useEffect, useMemo, useState } from 'react';
import formatTime from 'utils/formatTime';

type UmsAdminLoginLog = Awaited<
  ReturnType<typeof getUmsAdminLoginLog>
>['list'][number];

export const AdminLoginLogDialog = ({
  open,
  adminId,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
  adminId?: number;
}) => {
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState<UmsAdminLoginLog[]>([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setPageNum(1);
    setPageSize(10);
    setData([]);
    setTotal(0);
  }, [adminId]);

  useEffect(() => {
    if (!adminId || !open) return;
    getUmsAdminLoginLog({
      adminId,
      pageNum,
      pageSize,
    }).then((res) => {
      setData(res.list);
      setTotal(res.total);
    });
  }, [adminId, open, pageNum, pageSize]);

  const columns = useMemo(() => {
    return [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '结果',
        dataIndex: 'success',
        key: 'success',
        render: (success?: boolean) =>
          success ? (
            <Tag color="success">成功</Tag>
          ) : (
            <Tag color="error">失败</Tag>
          ),
      },
      {
        title: '登录时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (createTime: UmsAdminLoginLog['createTime']) => {
          return formatTime(createTime);
        },
      },
      {
        title: '登录IP',
        dataIndex: 'ip',
        key: 'ip',
      },
      {
        title: '登录地址',
        dataIndex: 'address',
        key: 'address',
      },
      {
        title: '登录UA',
        dataIndex: 'userAgent',
        key: 'userAgent',
      },
    ];
  }, []);

  return (
    <Modal open={open} onCancel={onClose} width="800px" footer={null}>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        pagination={{
          pageSize,
          total,
          current: pageNum,
          onChange: (page, pageSize) => {
            setPageNum(page);
            setPageSize(pageSize);
          },
        }}
      />
    </Modal>
  );
};
